export default {
  API_URL: 'https://pennon-api.cometrootapp.com/api/',
  SANDBOX_URL: 'https://pennonsandbox-api.cometrootapp.com/api/'
  // API_URL: 'https://localhost:44365/api',
  // SANDBOX_URL: 'https://localhost:44365/api'
}
